import script from "./PaymentPayerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentPayerCard.vue?vue&type=script&setup=true&lang=js"

import "./PaymentPayerCard.vue?vue&type=style&index=0&id=4fc5328d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc5328d"]])

export default __exports__